import styled from 'styled-components'
import Media from 'builder/styles/media'

export const Container = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 56px;

  ${Media.Phone`
    gap: 16px;
  `}
`

export const ContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  width: 100%;
  padding: 0 32px;

  ${Media.Tablet`
    gap: 48px;
    align-items: center;
    flex-direction: column;
    padding: 0 32px 48px;
  `}

  ${Media.Phone`
    padding: 0 20px 20px;
    gap: 19px;
  `}
`

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  width: 544px;

  ${Media.Tablet`
    width: 540px;
  `}

  ${Media.Phone`
    width: 100%;
    align-items: center;
  `}
`
